
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-mylo",
      function () {
        return require("private-next-pages/about-mylo/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-mylo"])
      });
    }
  